import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {MatrimonialProfile} from '../models/matrimonial-profile';
import {API_URL} from '../constants';

@Injectable({
    providedIn: 'root'
})
export class MatrimonialProfileService {
    private baseUrl = `${API_URL}matrimonial`;

    constructor(private http: HttpClient) {
    }

    createProfile(profile: MatrimonialProfile): Observable<MatrimonialProfile> {
        return this.http.post<MatrimonialProfile>(this.baseUrl, profile);
    }

    updateProfile(id: string, profile: MatrimonialProfile): Observable<MatrimonialProfile> {
        return this.http.put<MatrimonialProfile>(`${this.baseUrl}/${id}`, profile);
    }

    approveProfile(id: string): Observable<MatrimonialProfile> {
        return this.http.put<MatrimonialProfile>(`${this.baseUrl}/approve/${id}`, {});
    }

    getProfileById(id: string): Observable<MatrimonialProfile> {
        return this.http.get<MatrimonialProfile>(`${this.baseUrl}/${id}`);
    }

    deleteProfile(id: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`);
    }


    getProfiles(): Observable<MatrimonialProfile[]> {
        return this.http.get<MatrimonialProfile[]>(`${this.baseUrl}`);
    }

    getProfilesByUser(userId: string): Observable<MatrimonialProfile[]> {
        return this.http.get<MatrimonialProfile[]>(`${this.baseUrl}/user/${userId}`);
    }

    uploadBase64Image(id: string, base64Image: string, filename: string): Observable<any> {
        const payload = {
            base64Image: base64Image,
            filename: filename
        };

        return this.http.post<any>(`${API_URL}profile/matrimonial/upload-base64/${id}`, payload);
    }


    getProfileImageAsBlob(imageUrl: string): Observable<Blob> {
        const headers = new HttpHeaders({
            'Accept': 'image/jpeg'
        });

        return this.http.get(imageUrl, {
            headers,
            responseType: 'blob'
        });
    }


}
